<button type="button" class="btn btn-primary btn-sm mb-2 py-2 px-4 mb-md-0 " (click)="openAddModal(addEntryModal)">
    Add New
</button>


<ng-template #addEntryModal let-modal>
  <div class="modal-header">
    <h2 class="h5 modal-title mb-0" id="flow-tracking-add-title">Add New Flow Entry</h2>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form (ngSubmit)="saveEntry()" class="row" id="flow-tracking-add-form">
      <div class="form-group col-12 col-sm-6">
        <label for="flow_driver_name">Driver name</label>
        <input id="flow_driver_name" class="form-control" type="text" name="driver_name"
          [(ngModel)]="form.driver_name" required autocomplete="name">
      </div>

      <div class="form-group col-12 col-sm-6 mb-0">
        <label for="flow_truck_number">Truck number</label>
        <input id="flow_truck_number" class="form-control" type="text" name="truck_number"
          [(ngModel)]="form.truck_number" required>
      </div>

      <div class="form-group col-12 col-sm-6 mb-0 mt-3">
        <label for="flow_device_id">Device</label>
        <select id="flow_device_id" class="form-control" name="device_id"
          [(ngModel)]="form.device_id" required [disabled]="devices_loading || devices.length === 0">
          <option value="" disabled>
            {{ devices_loading ? 'Loading devices...' : (devices_error || (devices.length ? 'Select a device' : 'No devices available')) }}
          </option>
          <option *ngFor="let device of devices" [ngValue]="device.device_id">
            {{ device.location }}
          </option>
        </select>
      </div>

      <p *ngIf="form_error" class="text-danger mt-3 mb-0" role="alert">{{ form_error }}</p>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel click')">Cancel</button>
    <button type="submit" class="btn btn-primary" form="flow-tracking-add-form">Start Tracking</button>
  </div>
</ng-template>

<!-- <ng-template #stopConfirmModal let-modal>
  <div class="modal-header">
    <h2 class="h5 modal-title mb-0" id="flow-tracking-stop-title">Stop tracking</h2>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p class="mb-0">Are you sure you want to stop tracking.</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss('no click')">No</button>
    <button type="button" class="btn btn-danger" (click)="confirmStop()">Yes</button>
  </div>
</ng-template> -->
